import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import BoostsGif from "./images/usage_boosts.gif";
import hydration from "./images/hydration.jpg";
import One from "./images/one.png";
import OneActive from "./images/one_active.png";
import ProteinGif from "./images/usage.gif";
import Three from "./images/three.png";
import ThreeActive from "./images/three_active.png";
import Two from "./images/two.png";
import TwoActive from "./images/two_active.png";
import GreensGif from "CheckoutComponents/CheckoutResultsNew/CheckoutResultsProduct/CheckoutResultsProductDetailsDrawer/images/Greens1.png";
import styles from "./styles.module.scss";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
const images = {
    0: [One, OneActive],
    1: [Two, TwoActive],
    2: [Three, ThreeActive],
};
const data = {
    protein: {
        gif: ProteinGif,
        bullets: [
            {
                title: "Make Your Shake",
                text: "Add 1 scoop of Gainful Protein Powder to a blender bottle with 8 - 12 oz. of milk, milk-alternative, or water.  Mix in 1 delicious flavor boost and shake for 30 seconds. ",
            },
            {
                title: "When to Take",
                text: "Gainful Protein Powder can be taken anytime throughout the day. On days you exercise, it’s most effective immediately following your workout to speed up recovery. ",
            },
            {
                title: "Keep it Consistent",
                text: "Achieving your fitness goals requires consistent effort. Fueling your body with a regular supply of high-quality supplements and nutrition products can help you stay on track.",
            },
        ],
    },
    boosts: {
        gif: BoostsGif,
        bullets: [
            {
                title: "Daily Dose",
                text: `Mix 1 scoop with a product in your personalized Gainful system or add to at least 8 oz water, or beverage of your choice — as often as needed or as recommended by a healthcare or performance professional.`,
            },
            {
                title: "Recommended Use Case",
                text: `Ideally, use Creatine or Collagen 30-90 minutes before or after exercise. Mix with any of your personalized Gainful products. Fiber is best post-workout.`,
            },
            {
                title: "Repeat",
                text: `The journey is just as vital as the end result. Progress is the point. Enjoy the gains as they come.`,
            },
        ],
    },
    hydration: {
        gif: hydration,
        bullets: [
            {
                title: "How to Hydrate",
                text: `Mix 1 packet of Gainful Hydration into 8 - 16oz of water and shake for 30 seconds. If you like your drinks on the sweeter side, aim for less water.`,
            },
            {
                title: "When to Take",
                text: `Gainful Hydration can be taken anytime throughout the day – kickstart your morning with a glass, mix into your afternoon routine or drink after exercising to replenish your electrolytes.`,
            },
            {
                title: "Keep it Consistent",
                text: `Achieving your fitness goals requires consistent effort. Fueling your body with a regular supply of high-quality supplements and nutrition products can help you stay on track.`,
            },
        ],
    },
    preworkout: {
        gif: hydration,
        bullets: [
            {
                title: "How to Use Pre-Workout",
                text: `Mix 1 scoop of Gainful Pre-Workout into 8 - 16oz of water and shake for 30 seconds. If you like your drinks on the sweeter side, aim for less water.`,
            },
            {
                title: "When to Take",
                text: `Gainful Pre-Workout should be taken 20-30 minutes prior to exercise. Once activated, you may notice a tingle sensation which is totally natural.`,
            },
            {
                title: "Keep it Consistent",
                text: `Achieving your fitness goals requires consistent effort. Fueling your body with a regular supply of high-quality supplements and nutrition products can help you stay on track.`,
            },
        ],
    },
    greens: {
        gif: GreensGif,
        bullets: [
            {
                title: "How to Use Greens",
                text: "Pour 1 pack of Greens into water. For a lighter flavor, use 10-12oz of water. For a bolder flavor, use 8-9oz of water. Shake, stir, or blend to combine. Settling may naturally occur. Drink immediately, or shake before enjoying. Best served ice cold.",
            },
            {
                title: "When to Take",
                text: `We suggest mixing Greens into your daily routine whenever it suits you best. `,
            },
            {
                title: "Keep it Consistent",
                text: `Achieving your fitness goals requires consistent effort. Fueling your body with a regular supply of high-quality supplements and nutrition products can help you stay on track.`,
            },
        ],
    },
};
const HowToUseYourSystem = ({ product, }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    useEffect(() => {
        document.addEventListener("scroll", () => {
            const current_position = document.documentElement.scrollTop + 80;
            const window_height = window.innerHeight;
            const two = document.getElementById("bullet-1")?.offsetTop || 0;
            const three = document.getElementById("bullet-2")?.offsetTop || 0;
            const half = current_position + window_height / 2;
            if (half >= three) {
                setActiveIndex(2);
            }
            else if (half >= two) {
                setActiveIndex(1);
            }
            else {
                setActiveIndex(0);
            }
        });
    }, []);
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: product === "protein"
                        ? `${styles.gifContainer} ${styles.proteinGif}`
                        : styles.gifContainer, children: _jsx("img", { className: styles.gif, src: data[product].gif, alt: "usage" }) }), _jsxs("div", { className: styles.textContent, children: [_jsx(H2Font, { fontWeight: 400, children: "How to Use Your System" }), _jsx(RegFont, { children: "We designed our products to be easy-to-mix, match, and modify \u2014 so your body gets what it needs to prepare, perform and recover." }), _jsx("div", { className: styles["usage-container"], children: _jsx("ul", { className: styles["usage-list"], children: data[product].bullets.map((bullet, index) => (_jsxs("li", { id: "bullet-" + index, className: [
                                        activeIndex === index && styles["active"],
                                        styles.counter_wrapper,
                                    ].join(" "), children: [_jsxs("div", { className: styles["usage-counter"], children: [activeIndex === index ? (_jsx("img", { className: styles.counter_img, src: images[index][1], id: "icon-active-" + index, alt: "one" })) : (_jsx("img", { src: images[index][0], className: styles.counter_img, id: "icon-" + index, alt: "one" })), index <= 1 && _jsx("div", { className: styles["line"] })] }), _jsx(RegFont, { className: styles.counter_title, fontWeight: 400, children: bullet.title }), _jsx(RegFont, { children: bullet.text })] }, bullet.text))) }) })] })] }) }));
};
export default HowToUseYourSystem;
